import React, { useEffect, useMemo, useState } from 'react'
import { Col, Container, Row, Table, Image, Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ProductObj from '../products/productObj';
import { selectProducts } from '../products/productsSlice';
import { selectCartItems, setCartItem } from '../cart/cartSlice';
import { selectToken } from '../user/userSlice';
import Loader from '../../components/Loader';
import { selectIsMobileRoute } from '../mobile/mobileSlice';
import CartObj from '../cart/cartObj';

export default function MealFromURL() {
    const location = useLocation();
    const navigate = useNavigate();
    const products = useSelector(selectProducts);
    const cartItems = useSelector(selectCartItems);
    const cart = useMemo(() => {
      return new CartObj(cartItems);
    }, [cartItems]);
    const [userItems, setUserItems] = useState<string[]>([]);
    const dispatch = useDispatch();
    const token = useSelector(selectToken);
    const [isLoading, setIsLoading] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const couponCodeQuery = queryParams.get("coupon-code");
    const productCodeQuery = queryParams.get("product_id");
    const AppURL = useSelector(selectIsMobileRoute);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      const cartItemIds = Object.keys(cartItems).map(id => parseInt(id));
      const itemsMatched = userItems.every(itemId => cartItemIds.includes(parseInt(itemId)));

      if (userItems.length > 0 && !itemsMatched && productCodeQuery){
        fetchData();
      } else {
        if (couponCodeQuery && itemsMatched && userItems.length > 0 && !cart.isEmpty()) {
          navigate(`${location.pathname}?coupon-code=${couponCodeQuery}${AppURL}`);
        } else if (itemsMatched && !cart.isEmpty()) {
          navigate(`${location.pathname}${AppURL}`);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartItems]);

    const fetchData = () => {
      if (productCodeQuery && (productCodeQuery !== "" || productCodeQuery !== null)) {
        const productQueryArray = productCodeQuery.split(',');
        if (productQueryArray.length) {
          setIsLoading(true);
          setUserItems(productQueryArray);
          handleAddToCart(productQueryArray);
        }
      }
    }

    const handleAddToCart = async (userMeals: any) => {
      try {
        await userMeals.forEach((mealItems: any) => {
          const match = mealItems.match(/^(\d+)x(\d+)$/);
          const productId = Number(match?.[1] || mealItems);
          const quantity = Number(match?.[2] || 1);
          const product = ProductObj.getById(products, productId);
          if (product && product.data.price) {
            dispatch(
              setCartItem({
                token: token,
                cart_item: {
                  product_id: productId,
                  product_qty: quantity,
                  product_price: Number(product?.data?.price),
                },
              })
            );
          }
        });
      } catch (e) {
        console.error("Error:", e);
      } finally{
        setIsLoading(false);
      }      
    };

    return (
        <>
            <Container fluid="lg" className='my-meal-plans-page w-50 border border-dark'>
                <Modal
                    backdrop="static"
                    show={true}
                >
                    <Modal.Body className='font-barlow'>
                        <Row>
                            <Col className='d-flex flex-column p-2'>
                                <label className='table-borderless font-barlow d-flex justify-content-center h2 pb-3 fw-bold'>Please Wait ...</label>
                                {isLoading ? <Loader /> : (<>
                                <Table
                                    striped
                                    responsive
                                    className='table-borderless font-barlow border border-dark fs-6'>
                                        <thead>
                                            <tr>
                                                <th># Items</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userItems?.map((mealPlanData: any, index: any) => {
                                                const match = mealPlanData.match(/^(\d+)x(\d+)$/);
                                                const productId = Number(match?.[1] || mealPlanData);
                                                const product = ProductObj.getById(products, productId);
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            {product ?
                                                                <div className='d-flex'>
                                                                    <Image
                                                                        src={product?.data.images[0].src}
                                                                        width="50"
                                                                        height="50"
                                                                        className='d-none d-sm-block'
                                                                    />
                                                                    <span className='ms-2'>{product?.data.name}
                                                                    </span>
                                                                </div>
                                                                :
                                                                <div className='mt-2'>
                                                                    <Spinner animation="border" as="span" size="sm" title='Product Image Loading' />
                                                                    &nbsp;&nbsp;&nbsp;{mealPlanData?.productName}</div>
                                                            }</td>
                                                        <td>
                                                            {product && (<>
                                                                Adding to cart ...&nbsp;&nbsp;
                                                                <Spinner
                                                                    animation="border"
                                                                    as="span"
                                                                    size="sm"
                                                                /></>)}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                </Table></>) }
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    )
}